<template>
  <div class="bb-contact-document-form" v-click-outside="() => closeForm(false)">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"></loader-fly>
    </transition>
    <div class="bb-contact-document-form-header">
      <div>Log in a document</div>
      <i class="icon-cross bb-contact-document-form-header__close" @click.stop="closeForm(false)"/>
      <div
        class="bb-contact-document-form__upload-file"
        :class="{
          'bb-contact-document-form__upload-file_with-file' : fileDownload.id
        }"
      >
        <UploadFiles
          :titleDocument="fileDownload.name"
          :error="fileUploadError"
          @downLoadFile="uploadFile"
          @removeFile="removeFileHandler"

        />
        <transition name="fade" appear>
          <loader-fly
            v-if="loadingDownloadDocument"
            :blockMode="true"
          >
          </loader-fly>
        </transition>
      </div>
    </div>
    <div class="bb-contact-document-form-body">
      <Form :inputs-list="inputsDocs"
            :default-model="document"
            :errors="errors"
            :grid="gridForm"
            :clientCompanies="clientCompanies"
            :save="validateDataForm"
            :close="closeForm"
            @setPopupValue="setCompany"
            @change="getFormResult"/>
    </div>
    <div class="bb-contact-document-form-footer">
      <button class="bb-button bb-button_border bb-button_border_gray bb-contact-document-form-footer__btn"
              @click="closeForm(false)">
        CANCEL
      </button>
      <button class="bb-button bb-contact-document-form-footer__btn"
              :disabled="isDisableSend || !fileDownload.id || loadingDownloadDocument"
              @click="validateDataForm">
        {{ getAcceptBtnTitle }}
      </button>
    </div>
  </div>
</template>

<script>
import { get, set, some} from 'lodash'
import contactsDocsInputs from '@/constants/Forms/contactDocsForm'
import documentIcon from '@/assets/images/document-large.png'
import Form from '@/components/Main/Form/Form'
import {docsOwnTags} from '@/constants/documentTags'
import ContactDocsApi from '@/api/ContactDocs/api'
import moment from 'moment'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import UploadFiles from "@/components/Main/UploadFiles/UploadFiles";
import UploadFileApi from '@/api/UploadFile/api'
import setFileData from '@/mixin/setFileData'

export default {
  name: 'ContactDocumentsForm',
  components: {UploadFiles, Form, LoaderFly },
  props: ['setLoading', 'isDisableSend', 'editDocument'],
  mixins: [setFileData],
  data () {
    return {
      docIcon: documentIcon,
      errors: {},
      document: {},
      company: {},
      inputsDocs: [],
      gridForm: {
        columns: 'repeat(3, 255px)',
        rows: '1fr 97px',
        gap: '20px 14px'
      },
      loaderRun: false,
      loadingDownloadDocument: false,
      fileDownload: {},
      fileUploadError: '',
      crypt: true,
      removedFiles: [],
      initFileId: '',
      editDocumentId: '',
    }
  },
  computed: {
    getAcceptBtnTitle () {
      return this.editDocumentId ? 'SAVE' : 'ADD';
    },
    clientCompanies () {
      return this.$store.getters.clientCompanies
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    contactDocs: {
      get: function () {
        return this.$store.getters.contactDocs
      },
      set: function (data) {
        this.$store.dispatch('setContactDocs', data)
      }
    }
  },
  methods: {
    removeFileHandler() {
      const fileId = get(this.fileDownload, 'id', '');
      this.removedFiles.push(fileId);
      this.fileDownload = {};
    },
    async uploadFile (fileData) {
      this.loadingDownloadDocument = true;
      const file = this.setFileData(fileData);
      try {
        if (this.fileDownload.id) {
          this.removedFiles.push(this.fileDownload.id);
        }
        const { data } = await UploadFileApi.createFile(file, this.crypt);
        this.fileDownload = {...data, name: data.label};
        this.fileUploadError = '';
      } catch (e) {
        this.fileUploadError = 'Error of upload file!';
      } finally {
        this.loadingDownloadDocument = false;
      }
    },
    deleteFiles (isSave) {
      if (!isSave && !this.initFileId && this.fileDownload.id) {
        //1 case - if create new file -> download file and exit
        UploadFileApi.deleteFile(this.fileDownload.id, this.crypt);
        this.removedFiles.forEach(fileId => {
          UploadFileApi.deleteFile(fileId, this.crypt);
        });
      } else if (!isSave && this.initFileId) {
        //2 case - if edit document -> change file  and exit
       this.removedFiles.forEach(fileId => {
          if (fileId !== this.initFileId) {
            UploadFileApi.deleteFile(fileId, this.crypt);
          }
        });
       if (this.fileDownload.id && this.fileDownload.id !== this.initFileId) {
         UploadFileApi.deleteFile(this.fileDownload.id, this.crypt);
       }
      } else {
        //save form
        this.removedFiles.forEach(fileId => {
          if (fileId !== this.initFileId) {
            UploadFileApi.deleteFile(fileId, this.crypt);
          }
        });
      }
    },
    setCompany (company) {
      if (!company) return;
      this.document.clientCompany = company;
      this.company = company;
    },
    setDefaultErrors () {
      this.errors = {
        label: false,
        own: false,
        tag: false
      }
    },
    getFormResult (object) {
      this.setDefaultErrors();
      this.document = {...object};
    },
    closeForm (isSave) {
      if (this.loadingDownloadDocument) return;
      this.deleteFiles(isSave);
      this.$emit('close');
    },

    checkRequired () {
      this.inputsDocs.forEach(input => {
        if (input.require) {
          const value = get(this.document, input.model)
          const error = value ? false : 'mandatory field'
          set(this.errors, input.model, error)
        }
      })
    },
    validateDataForm () {
      this.checkRequired()
      const hasError = some(this.errors, item => item !== false)
      if (hasError) return
      this.sendForm()
    },
    setValuesForRequest (document) {
      const result = {
        label: document.label,
        client: this.clientInfo.id,
        comment: document.comment || '',
        own: get(document, 'own.id', ''),
        tag: get(document, 'tag.id', ''),
        locationDocument: 2,
        uploadFile: get(this.fileDownload, 'id', '')
      }
      const ownCorporate = get(document, 'own.id', '') === 2
      if (ownCorporate && this.company.id) {
        result.clientCompany = this.company.id
      }
      return result
    },
    getDate (item) {
      return item.date ? moment(item.date).format('DD-MMM-YY') : 'N/A'
    },
    async sendForm () {
      this.loaderRun = true;
      const document = this.setValuesForRequest(this.document);

      try {
        if (this.editDocumentId) {
          await this.updateDocument(document, this.editDocumentId);
        } else {
          await this.createDocument(document);
        }
        this.closeForm(true);
      } catch (e) {
        console.error(e);
      } finally {
        this.loaderRun = false;
      }
    },
    setInputsList () {
      this.inputsDocs = contactsDocsInputs.map(item => {
        if (item.id === 'own' && this.clientCompanies.length === 0) {
          /** @see docsOwnTags */
          item.list = docsOwnTags.filter(tag => tag.id !== 2)
        } else if (item.id === 'own') {
          item.list = docsOwnTags
        }
        return item
      });

      if (this.editDocument.id) {
        const { uploadFile, uploadFileLabel, ...restDocument } = this.editDocument;
        this.document = restDocument;
        this.fileDownload = {
          name: uploadFileLabel,
          id: uploadFile,
        };
        this.initFileId = uploadFile;
        this.editDocumentId = this.editDocument.id;
      }

    },
    async createDocument(document) {
      const { data } = await ContactDocsApi.createContactDoc(document);
      this.document.locationDocument = 2;
      this.document.uploadFileLabel = this.fileDownload.name;
      this.document.uploadFile = data.uploadFile.id;
      this.document.id = data.id;
      this.document.formatDate = this.getDate(data);
      this.contactDocs.push(this.document);
    },
    async updateDocument(document, id) {
      const { data } = await ContactDocsApi.updateContactDoc(document, id);
      this.$emit('updateDocument', {
        ...data,
        uploadFile: {
          ...data.uploadFile,
          _id: data.uploadFile.id,
        }
      });
    },
  },
  beforeMount () {
    this.setInputsList();
    this.setDefaultErrors();
  },
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-contact-document-form {
    position: relative;
    background-color: $color-white;
    border-radius: 8px;
    min-width: 480px;

    &-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      margin-top: 14px;

      &__close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        position: absolute;
        top: 6px;
        right: 6px;
        font-size: 18px;
        cursor: pointer;
        color: $color-silver;
        z-index: 1;
      }
    }

    &__upload-file {
      width: 100%;
      padding: 0 18px;
      margin: 12px 0;
      position: relative;

      &_with-file {
        width: auto;
      }
    }

    &-document {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 14px 21px;
      margin: 12px auto;
      background: $color-polar;
      border: 1px dashed rgba($color-accent, 0.3);
      box-sizing: border-box;
      border-radius: 4px;

      &_error {
        border: 1px dashed rgba($color-red, 0.3);
        background: rgba($color-red, 0.1);
      }

      &__text-error {
        position: absolute;
        bottom: -18px;
        right: 0;
        color: $color-red-orange;
        font-size: 11px;
        line-height: 13px;
        white-space: nowrap;
      }

      &__icon {
        width: 27px;
        height: 27px;
        margin-right: 9px;
      }

      &__filename {
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
      }
    }

    &-body {
      margin: 0 13px 30px 18px;
      padding-right: 5px;
      max-height: 200px;
      overflow: hidden;
    }

    &-footer {
      display: grid;
      grid-template-columns: repeat(2, 103px);
      grid-gap: 12px;
      justify-content: end;
      border-top: 1px solid $color-mercury;
      padding: 19px 18px;
      background: $color-wild-sand;
      border-radius: 0 0 8px 8px;

      &__btn {
        font-weight: 600;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactDocuments/ContactDocumentsForm/ContactDocumentsForm.vue